import logging from '@wr/logging';
import {useState} from 'react';
import {getErrorStatusCode} from './getErrorStatusCode';
import config from '../config';

const logger = logging.createLogger(config.app.name, config.logger.logServerUrl);

export const useFetchData = ({
    initErrorCode,
    initData,
    fetch
}) => {
    const [errorCode, setErrorCode] = useState(initErrorCode);
    const [data, setData] = useState(initData || undefined);
    const [loading, setLoading] = useState(false);

    const fetchData = async () => {
        try {
            const newData = await fetch();
            setData(newData);
        } catch (error) {
            logger.error(error);
            setErrorCode(getErrorStatusCode(error));
        } finally {
            setLoading(false);
        }
    };

    if (data === undefined && !errorCode && !loading) {
        setLoading(true);
        fetchData();
    }

    return {
        data,
        loading,
        errorCode
    };
};
